import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { COE_DOCUMENTS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/coe/documents/new")({
  component: () => <DeptContentForm cfg={COE_DOCUMENTS} />,
});
